import * as React from "react";
import { Link } from "react-router-dom";

import { IconButton, Tooltip } from "@material-ui/core";
import GetAppOutlinedIcon from "@material-ui/icons/GetAppOutlined";

import { DownloadRoute } from "Routes";

import { IButtonProps } from "./IButtonProps";

export function DownloadButton(props: IButtonProps): React.ReactElement | null {
    return (
        <Tooltip title="Download wallpaper">
            <span>
                <IconButton size="small" color="primary" component={Link} to={DownloadRoute.path}>
                    <GetAppOutlinedIcon/>
                </IconButton>
            </span>
        </Tooltip>
    )
}